import { foldingScroll, reloadHeader, submitGA, submitMobileMenuGA, waitForLoginPopup, initializeStuff } from './util';
import { initializeChatsCounter, initializeChatsNotificator } from './services/chats';
import { handleDownloadAppClick } from './utils/handleDownloadAppClick';
import { getConfig } from '@cian/config/browser';
import { initializeDropdownMenus } from './services/dropdownMenus';
import { initializeSpecialPromoLink } from './services/specialPromoLink';
require('./style-mobile.css');

const burger = document.getElementById('burger');
const menuBg = document.getElementById('nav-bg');
const closeButton = document.getElementById('nav-close');
const downloadAppButton = document.getElementById('download-app');
const adaptiveMenu = document.getElementById('adaptive-menu');
const menu = document.getElementById('adaptive-header');
const body = document.querySelector('body');
const html = document.documentElement;

let htmlOverflow = '';
let bodyOverflow = '';

if (burger) {
  burger.onclick = () => {
    if (burger && adaptiveMenu && menu && body) {
      adaptiveMenu.className += ' c-header__main-nav-opened';
      adaptiveMenu.classList.remove('c-header__main-nav-hidden');
      menu.className += ' c-header-opened';
      htmlOverflow = html.style.overflow;
      bodyOverflow = body.style.overflow;
      // Если не скрывать переполнение для html - скрытие не работает должным образом на ios
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
    }
  };
}

const closeMenu = () => {
  if (adaptiveMenu && menu) {
    adaptiveMenu.classList.remove('c-header__main-nav-opened');
    menu.classList.remove('c-header-opened');
    setTimeout(() => {
      if (adaptiveMenu && body) {
        adaptiveMenu.className += ' c-header__main-nav-hidden';
        html.style.overflow = htmlOverflow;
        body.style.overflow = bodyOverflow;
      }
    }, 300);
  }
};

if (menuBg) {
  menuBg.onclick = closeMenu;
}

if (closeButton) {
  closeButton.onclick = closeMenu;
}

if (downloadAppButton) {
  downloadAppButton.onclick = handleDownloadAppClick;
}

window.onload = () => {
  const config = getConfig();
  const userIsAuthenticated = config.get<boolean>('userIsAuthenticated') as boolean;

  if (window.__header_dropdown_menus_data__) {
    initializeDropdownMenus({ newHeaderEnabled: false });
  }

  initializeStuff();

  return setTimeout(() => {
    initializeDropdownMenus({});
    initializeChatsCounter();
    initializeSpecialPromoLink();

    if (userIsAuthenticated) {
      initializeChatsNotificator();
    }

    if (window.__header_enable_folding_scroll__) {
      const header = document.getElementById('adaptive-header');

      if (header) {
        const handleScroll = foldingScroll(header);

        window.addEventListener('scroll', handleScroll);
      }
    }
  }, 1000);
};

window.reloadHeader = reloadHeader;
window.refreshAfterUserLoggedIn = reloadHeader;
window._headerTrackingEvent = submitGA;
window._mobileMenuTrackingEvent = submitMobileMenuGA;
window.waitForLoginPopup = waitForLoginPopup;
